import React from 'react';
import './embeds.css';

// Actions are intentionally ignored/hidden until backed by real behaviors.
export default function CardEmbed({ title, subtitle, stats = [] }) {
  return (
    <div className="embed-card">
      {(title || subtitle) && (
        <div className="embed-card-header">
          {title && <div className="embed-card-title">{title}</div>}
          {subtitle && <div className="embed-card-subtitle">{subtitle}</div>}
        </div>
      )}
      {stats?.length > 0 && (
        <div className="embed-card-stats">
          {stats.map((s, idx) => (
            <div key={idx} className="embed-card-stat">
              <div className="stat-label">{s.label}</div>
              <div className="stat-value">{s.value}</div>
              {s.delta && <div className={`stat-delta ${s.trendDirection || ''}`}>{s.delta}</div>}
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
